// extracted by mini-css-extract-plugin
export var container = "default-module--container--edca7";
export var contents = "default-module--contents--5d3d5";
export var contentsWrapper = "default-module--contents-wrapper--27950";
export var fontBold = "default-module--font-bold--e6812";